export default __webpack_public_path__ + "static/media/ico_usuarios.2af70111.svg";